import { styled } from 'styles';

export const StyledForm = styled.form`
  margin: 0;
  padding: 0;
  width: 100%;
`;

StyledForm.displayName = 'Form';
